/**
 * Seizure charting entry (Phase 18 M8).
 */

import { BaseEntryData } from './chart-entry.dto';

export const SEIZURE_INTERVENTIONS = ['REPOSITION', 'O2', 'SUCTION', 'RESCUE_MED', 'VNS', 'EMS'] as const;
export type SeizureIntervention = typeof SEIZURE_INTERVENTIONS[number];

export interface SeizureData extends BaseEntryData {
  /** ISO time, within the visit like observedAt */
  startedAt: string;
  /** 0–7200 */
  durationSeconds?: number;
  seizureType?: string;
  description?: string;
  interventions?: SeizureIntervention[];
  /** A MEDICATION entry in the same visit */
  rescueMedEntryId?: string;
  postIctalState?: string;
  notified?: string[];
  notes?: string;
}
